export const submitMessageSettings = {
  submitMessageTitle: 'Thank you!',
  submitMessageText: 'Your submission has been successfully sent.',
  submitMessageAlignment: 'center' as const,
  submitMessageTitleColor: 'rgb(17, 17, 17)',
  submitMessageTextColor: 'rgba(17, 17, 17, 0.5)',
  submitMessageButtonColor: 'rgb(25, 123, 255)',
  submitMessageTitleFontStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal',
    textTransform: undefined
  } as const,
  submitMessageTextFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal'
  } as const,
  submitMessageButtonTextFontStyle: {
    fontSize: 15,
    fontWeight: 'bold',
    fontStyle: 'normal'
  } as const,
  submitMessageButton: true,
  submitMessageButtonText: 'OK'
};

export type SubmitMessageSettings = typeof submitMessageSettings;
